module.exports = __webpack_public_path__ + "static/aftermath1-a6911fab8f2e8971b2f805f7e17eb5f0.jpg";